import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import SelectBox from "../../../../components/SelectBox";
import { isFieldDisabled } from "../../../../utils/validators";
import { useAxiosWithAuthorization } from "../../../../utils/api";
import useAppContext from "../../../../utils/Reducers";
import Grade from "./grade";
import History from "./history";
import Order from "./order";

const GradeConfirmPop = ({ inspData, onClose }) => {
  //차량 검색 URL
  //공통코드 검색 URL
  //console.log(inspData);
  const {
    store: { userInfo },
  } = useAppContext();

  const SEARCH_CODE_URL = "/common/code/searchDetailCode.do";
  const [scrapAreaCd, setScrapAreaCd] = useState("");
  const [menuTab, setMenuTab] = useState("grade");
  const [show, setShow] = useState(true);
  const [hide, setHide] = useState(false);
  const handleClose = (returnData) => {
    onClose();
    setShow(false);
  };

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [""],
    updated: ["systemCd"],
  };

  const initItem = {

    systemCd: inspData.systemCd,
    inspNo: inspData.wssId,
    wssId: inspData.wssId,
    inspDt: "",
    plantCd1: inspData.plantCd1,
    plantCd: inspData.plantCd,
    transCd: inspData.transCd,
    transCdNm: inspData.transCdNm,
    vhclNo: inspData.vhclNo,
    vhclType: inspData.vhclType,
    totalWeight: inspData.totalWeight,
    itemCd: inspData.itemCd,
    itemNm: inspData.itemNm,
    vndrCd: inspData.vndrCd,
    vndrNm: inspData.vndrNm,
    rvndrCd: inspData.rvndrCd,
    rvndrNm: inspData.rvndrNm,
    loadAreaCd: inspData.loadAreaCd,
    loadAreaNm: inspData.loadAreaNm,
    scrapAreaCd: inspData.scrapAreaCd,
    scrapAreaNm: "",
    magnet: "",
    dcsnItemCd: "",
    subItemCd1: "",
    subItemPrdCd1: "",
    subItemRate1: "",
    subItemCd2: "",
    subItemPrdCd2: "",
    subItemRate2: "",
    subItemCd3: "",
    subItemPrdCd3: "",
    subItemRate3: "",
    outageCd: "",
    outageWght: "",
    outageRsn: "",
    returnCd: "",
    returnWght: "",
    returnRsn: "",
    dprctCd: "",
    dprctRate: "",
    scalNo: "",
    tmsOdrNo: inspData.tmsOdrNo,
    workerId: "",
    inspCd: "R",
    rmks: "",
    inptDt: inspData.inptDt,
    returnCnt: inspData.returnCnt,
  };

  const [state, setState] = useState("created");

  const [fieldValues, setFieldValues] = useState(initItem);
  if (inspData.inspNo === "" || inspData.inspNo === null) {
    inspData.outageWght = "";
  }
  useEffect(() => {
    //setFieldValues(initItem);
  }, []);

  const onHide = () => {
    setHide(!hide);
  };

  const onMenuTab = (menuNm) => {
    setMenuTab(menuNm);
  };
  return (
    <>
      <Modal
        className="modal-fullscreen-md-down ims orenges"
        show={show}
        onHide={() => handleClose(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {inspData.inspNo === "" || inspData.inspNo === null
              ? inspData.wssId
              : inspData.inspNo}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={hide ? "infotype on" : "infotype"} onClick={onHide}>
            <div>
              <div className="micon trans">
                <div></div>
                <p>차량번호</p>
              </div>
              <div className="inf">
                <div>
                  <h3>
                    {fieldValues.vhclNo} / {fieldValues.plantNm}
                  </h3>
                </div>
              </div>
            </div>
            <div>
              <div className="micon box">
                <div></div>
                <p>입차중량</p>
              </div>
              <div className="inf">
                <div>
                  <h3>{fieldValues.totalWeight}kg</h3>
                </div>
              </div>
            </div>

            <div>
              <div className="micon time">
                <div></div>
                <p>입차일시</p>
              </div>
              <div className="inf">
                <div>
                  <h3>
                    {fieldValues.inptDt} / {fieldValues.scrapAreaNm}
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <ul className="tab tps">
            <li onClick={(event) => onMenuTab("grade")}>
              <div className={menuTab === "grade" ? "on" : ""}>검수진행</div>
            </li>
            <li onClick={(event) => onMenuTab("history")}>
              <div className={menuTab === "history" ? "on" : ""}>검수이력</div>
            </li>
            <li onClick={(event) => onMenuTab("order")}>
              <div className={menuTab === "order" ? "on" : ""}>배차정보</div>
            </li>
          </ul>

          {menuTab === "grade" ? (
            <Grade inspData={inspData} onClose={handleClose} />
          ) : menuTab === "history" ? (
            <History inspData={inspData} onClose={handleClose} />
          ) : menuTab === "order" ? (
            <Order inspData={inspData} onClose={handleClose} />
          ) : (
            ""
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export const ModalGradeConfirmPop = createModal(GradeConfirmPop);

export default GradeConfirmPop;
